// Projects preference — two device stores for All projects (the impure
// half; the folds and parsers are pure, in components/Projects):
//  - the view: sort, order, Cards or Table (projectsView.ts);
//  - where the author was in each project (projectPlaces.ts), written as
//    they move through a project's Studio and read when they open it again.
//
// The design says per person; there is no server-side preference store yet,
// so like the recent lists and the rail this is DEVICE display chrome
// (memory project_theme_outside_event_log): its own localStorage key, never
// a domain event. Each store is read once, advanced only through its fold,
// written back on every change, and notifies its subscribers.

export { projectPlaceOf, useProjectPlaces, useProjectsView, writeProjectPlace };

import { useSyncExternalStore } from "react";
import {
    type ProjectPlaces,
    parseProjectPlaces,
    recordPlace,
    serializeProjectPlaces,
} from "../components/Projects/projectPlaces.js";
import {
    foldProjectsView,
    type ProjectsView,
    type ProjectsViewCommand,
    parseProjectsView,
    serializeProjectsView,
} from "../components/Projects/projectsView.js";
import type { DeskState } from "../components/Studio/studioDesk.js";
import { mkDeviceFoldStore } from "./deviceStore.js";

const viewStore = mkDeviceFoldStore<ProjectsView, ProjectsViewCommand>(
    "bilda.projectsView",
    parseProjectsView,
    serializeProjectsView,
    foldProjectsView,
);

type PlaceLeft = { readonly projectId: string; readonly desk: DeskState };

const placesStore = mkDeviceFoldStore<ProjectPlaces, PlaceLeft>(
    "bilda.projectPlaces",
    parseProjectPlaces,
    serializeProjectPlaces,
    (places, left) => recordPlace(places, left.projectId, left.desk),
);

const useProjectsView = (): readonly [
    ProjectsView,
    (cmd: ProjectsViewCommand) => void,
] => [
    useSyncExternalStore(viewStore.subscribe, viewStore.get),
    viewStore.dispatch,
];

const useProjectPlaces = (): ProjectPlaces =>
    useSyncExternalStore(placesStore.subscribe, placesStore.get);

// The page shown in a project's Studio, as the author moves.
const writeProjectPlace = (projectId: string, desk: DeskState): void =>
    placesStore.dispatch({ projectId, desk });

// Where the author was in a project, for the host opening it.
const projectPlaceOf = (projectId: string): DeskState | undefined =>
    placesStore.get().get(projectId);
